import {SelectModel} from '../../lavanderia/model'

export const searchId = (array: SelectModel[], value: string, key: string) => {
  const id = array?.find((item) => item.label === key && item.value === value) || null
  return id ? true : false
}

export const searchItemId = (array: SelectModel[], value: string, key: string) => {
  const id = array?.find((item) => item.value === value) || null
  if (id?.label === key) {
    return true
  } else {
    return false
  }
}
